window.TeamLiveShiftOfferFinancialsApi = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['TeamLiveShiftOfferFinancials']);

    self.getPublishViolations = async (brandId, scheduleId, payload) => {
        const res = await _protected.request(`brands/${brandId}/schedules/${scheduleId}/publish/violations`, "POST", payload);

        if (res?.data?.data) {
            return res.data.data;
        }

        throw res;
    };

    self.generatePublishToken = async (brandId, scheduleId, payload) => {
        const v2Url = self.apiUrl.replace('v1', 'v2');

        const response = await _protected.request(`${v2Url}brands/${brandId}/schedules/${scheduleId}/publish/acquire_token`, "POST", payload);
        if (response?.data?.data) {
            return response.data.data;
        }
        throw response;
    }

    self.getUserShifts = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/users/working_days", "GET", params)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    defer.resolve(res.data.data.users || []);
                } else {
                    defer.reject();
                }
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };
});